<template>
  <div class="detail-box position-header" v-loading="loading">
    <navHeader :titleList="['商家信息']" />
    <div class="detail-content common-padding">
      <el-card class="box-card">
        <el-row type="flex" justify="center">
          <el-col :span="18">
            <el-form
              ref="basicForm"
              class="add-form"
              :rules="basicRules"
              :model="basicForm"
              label-width="120px"
            >
              <el-form-item label="审核状态：">
                <span :class="basicForm.status === '3' ? 'bhText' : 'otherText'" >{{basicForm.status === '2' ? '审核通过' :(basicForm.status === '3' ? '审核驳回' : '待审核')}}</span>
                <span v-if="basicForm.status === '3'" class="bhText">{{basicForm.reason}}</span>
              </el-form-item>
              <el-form-item :label="isDr ? '机构名称' : '公司名称：'">
                <el-input v-model="basicForm.fullName" disabled></el-input>
              </el-form-item>
              <el-form-item :label="isDr ? '机构简称' : '简称：'" prop="shortName">
                <el-input
                  v-model="basicForm.shortName"
                  placeholder="不超过10个字"
                ></el-input>
              </el-form-item>
              <el-form-item :label="isDr ? '机构英文名' : '英文名：'">
                <el-input v-model="basicForm.englishName" disabled></el-input>
              </el-form-item>
              <el-form-item label="展商手机号码：">
                <el-input v-model="mobile" disabled></el-input>
              </el-form-item>
              <el-form-item label="商家类型：">
                <el-select filterable  v-model="basicForm.type" style="width: 100%" disabled>
                  <el-option
                      v-for="(item,index) in typeList"
                      :key="index"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="简介" prop="introduction">
                <el-input v-model.trim="basicForm.introduction" type="textarea" :rows="10"></el-input>
              </el-form-item>
              <el-row :key="index" v-for="(item, index) of basicForm.sceneRosterList" type="flex" justify="center" :gutter="10">
                <el-col :span="24">
                  <el-form-item label="参展展会：" prop="sceneId">
                    <el-select
                        filterable
                        style="width: 100%"
                        v-model="item.sceneId"
                        placeholder="请选择"
                        :disabled="item.id"
                    >
                      <el-option
                          v-for="item in cbeList"
                          :key="item.id"
                          :label="item.title"
                          :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="展馆：" prop="">
                    <el-input v-model="item.showroom" :disabled="item.id"></el-input>
                  </el-form-item>
                  <el-form-item label="展位号：" prop="">
                    <el-input v-model="item.boothNumber" :disabled="item.id"></el-input>
                  </el-form-item>
                  <el-form-item label="展位数：" prop="">
                    <el-input-number v-model="item.boothCount" :disabled="item.id"></el-input-number>
                  </el-form-item>
                  <el-form-item label="展位面积：" prop="">
                    <el-input-number v-model="item.area" :disabled="item.id"></el-input-number>
                  </el-form-item>
                  <el-form-item label="合同号：" prop="">
                    <el-input v-model="item.contractNo" :disabled="item.id"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="8"
                  ><el-form-item label="地址：" prop="province">
                    <el-select
                        filterable
                        style="width: 100%"
                      v-model="basicForm.province"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in areaCodeList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select> </el-form-item
                ></el-col>
                <el-col :span="12"
                  ><el-form-item label-width="0" prop="address">
                    <el-input
                      v-model.trim="basicForm.address"
                    ></el-input> </el-form-item
                ></el-col>
                <el-col :span="4" style="height: 62px; padding-top: 22px">
                  <el-button
                    type="primary"
                    style="float: right"
                    @click="addAddress"
                    >添加</el-button
                  >
                </el-col>
              </el-row>
              <el-form ref="factoryForm1"
                       class="add-form"
                       :rules="addressRules"
                       :model="addressForm"
                       label-width="120px">
              <el-row
                :gutter="10"
                v-for="(item, index) in addressForm.addressList"
                :key="index"
              >
                <el-col :span="8"
                  ><el-form-item label="地址：">
                    <el-select
                        filterable
                        style="width: 100%"
                      v-model="item.province"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in areaCodeList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select> </el-form-item
                ></el-col>
                <el-col :span="12"
                  ><el-form-item label-width="0">
                    <el-input v-model.trim="item.address"></el-input> </el-form-item
                ></el-col>
                <el-col :span="4" style="height: 62px; padding-top: 22px">
                  <el-button
                    type="warning"
                    style="float: right"
                    @click="deleteAddress(index)"
                    >删除</el-button
                  >
                </el-col>
              </el-row>
              </el-form>
              <el-form-item label="荣誉：" v-if="!isDr">
                <el-input v-model="basicForm.url" disabled></el-input>
              </el-form-item>
              <el-form-item label="客户经理：">
                <el-input v-model="basicForm.manager" disabled></el-input>
              </el-form-item>
              <el-form-item label="有效期：">
                <el-input v-model="basicForm.validityDate" disabled></el-input>
              </el-form-item>
              <el-form-item :label="(factoryShow || serviceShow) ? 'logo：' : '宣传图：' " prop="logo">
                <uploadImage @success="getLogo" :img="logoList" v-if="factoryShow || serviceShow" />
                <propagandaUpload @success="getLogo" :img="logoList" v-else :size="2" />
              </el-form-item>
              <el-form-item label="视频：" prop="videoUrl">
                <videoUpload @success="getVideo" :list="videoList"  />
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
        <!-- 工厂管理 -->
        <el-row type="flex" justify="center">
          <el-col :span="18" v-if="factoryShow">
            <el-form
              ref="factoryForm1"
              class="add-form"
              :rules="factoryRules"
              :model="factoryForm"
              label-width="140px"
            >
              <el-form-item label="是否做外贸：" prop="foreignTrade">
                <el-radio-group v-model="factoryForm.foreignTrade">
                  <el-radio label="1">是</el-radio>
                  <el-radio label="2">否</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="外贸占比：" prop="foreignTradeProportion" v-if="factoryForm.foreignTrade === '1'">
                <el-input v-model="factoryForm.foreignTradeProportion"></el-input>
              </el-form-item>
              <el-form-item label="是否支持定制：" prop="isCustomization">
                <el-radio-group v-model="factoryForm.isCustomization">
                  <el-radio label="1">是</el-radio>
                  <el-radio label="2">否</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="工厂面积：" prop="factoryArea">
                <el-input v-model="factoryForm.factoryArea"></el-input>
              </el-form-item>
              <el-form-item label="一级品类：" prop="one">
                <el-radio-group v-model="factoryForm.one" @change="oneChange">
                  <template v-for="(item, index) in oneList">
                    <el-radio :label="item.id" :key="index">{{
                      item.name
                    }}</el-radio>
                  </template>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="二级品类：" prop="selectTwo">
                <el-checkbox-group v-model="factoryForm.selectTwo" @change="getSelectMainList">
                  <template v-for="(item, index) in twoList">
                    <el-checkbox :label="item.id" :key="index">{{
                      item.name
                    }}</el-checkbox>
                  </template>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="主推品类：" prop="mainList">
                <el-checkbox-group v-model="factoryForm.mainList" :max="3">
                  <template v-for="(item, index) in selectMainList">
                    <el-checkbox :label="item.id" :key="index">{{
                      item.name
                    }}</el-checkbox>
                  </template>
                </el-checkbox-group>
              </el-form-item>
              <!-- 当“一级品类”选择“OEM&ODM”时，需填写字段 -->
              <div v-if="fieldName.indexOf('OEM&ODM') !== -1">
                <el-form-item label="服务范围：" prop="serviceRangeList">
                  <el-checkbox-group v-model="factoryForm.serviceRangeList">
                    <el-checkbox label="OEM"></el-checkbox>
                    <el-checkbox label="ODM"></el-checkbox>
                    <el-checkbox label="OBM"></el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
                <el-form-item label="是否能产品备案：" prop="recording">
                  <el-radio-group v-model="factoryForm.recording">
                    <el-radio label="1">是</el-radio>
                    <el-radio label="2">否</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="年产量：">
                  <el-input
                    v-model="factoryForm.yearlyOutput"
                  ></el-input>
                </el-form-item>
                <el-form-item label="研发人数：">
                  <el-input
                    type="number"
                    v-model="factoryForm.devPeople"
                  ></el-input>
                </el-form-item>
                <el-form-item label="原料备案数：">
                  <el-input
                    type="number"
                    v-model="factoryForm.formulaNum"
                  ></el-input>
                </el-form-item>
                <el-form-item label="专利数：">
                  <el-input
                    type="number"
                    v-model="factoryForm.patent"
                  ></el-input>
                </el-form-item>
                <el-form-item label="起订量：">
                  <el-input
                    type="number"
                    v-model="factoryForm.minOrder"
                  ></el-input>
                </el-form-item>
              </div>
              <!-- 当“一级品类”选择“包装或材料”时，需填写字段 -->
              <div v-if="fieldName.indexOf('包装') !== -1" >
                <el-form-item label="是否可以设计：" prop="design">
                  <el-radio-group v-model="factoryForm.design">
                    <el-radio label="1">是</el-radio>
                    <el-radio label="2">否</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="模具数量：">
                  <el-input
                    type="number"
                    v-model="factoryForm.modelNum"
                  ></el-input>
                </el-form-item>
                <el-form-item label="专利数：">
                  <el-input
                    type="number"
                    v-model="factoryForm.patent2"
                  ></el-input>
                </el-form-item>
                <el-form-item label="年产量：">
                  <el-input
                    type="number"
                    v-model="factoryForm.yearlyOutput2"
                  ></el-input>
                </el-form-item>
                <el-form-item label="起订量：">
                  <el-input
                    type="number"
                    v-model="factoryForm.minOrder2"
                  ></el-input>
                </el-form-item>
                <el-form-item label="包装开发人数：" prop="packingDevelopNum">
                  <el-input type="number" v-model="factoryForm.packingDevelopNum"></el-input>
                </el-form-item>
              </div>
              <!-- 当“一级品类”选择原料时，需填写字段 -->
              <div v-if="fieldName.indexOf('原料') !== -1 || fieldName.indexOf('材料') !== -1">
                <el-form-item label="年产值：">
                  <el-input
                    type="number"
                    v-model="factoryForm.yearlyOutput3"
                  ></el-input>
                </el-form-item>
                <el-form-item label="研发人数：">
                  <el-input
                    type="number"
                    v-model="factoryForm.devPeople3"
                  ></el-input>
                </el-form-item>
                <el-form-item :label="fieldName.indexOf('原料') !== -1 ? '原料备案数：' : '材料产品数：'">
                  <el-input
                    type="number"
                    v-model="factoryForm.formulaNum3"
                  ></el-input>
                </el-form-item>
                <el-form-item label="专利数：">
                  <el-input
                    type="number"
                    v-model="factoryForm.patent3"
                  ></el-input>
                </el-form-item>
                <el-form-item label="起订量：">
                  <el-input
                    type="number"
                    v-model="factoryForm.minOrder3"
                  ></el-input>
                </el-form-item>
              </div>
              <!-- 当“一级品类”选择“机械设备”时，需填写字段 -->
              <div v-if="fieldName.indexOf('机械设备') !== -1">
                <el-form-item label="研发工程师数：">
                  <el-input
                    type="number"
                    v-model="factoryForm.devPeople4"
                  ></el-input>
                </el-form-item>
                <el-form-item label="专利数：">
                  <el-input
                    type="number"
                    v-model="factoryForm.patent4"
                  ></el-input>
                </el-form-item>
                <el-form-item label="年产值：">
                  <el-input
                    type="number"
                    v-model="factoryForm.yearlyOutput4"
                  ></el-input>
                </el-form-item>
              </div>
              <el-form-item label="工厂图：" prop="factoryPic">
                <xcUpload @success="getFactoryPic" :img="factoryPicList" :limit="20" />
              </el-form-item>
              <el-form-item label="合作客户：">
                <el-button type="text" @click="providerPartnerVisible = true"
                  >添加合作客户</el-button
                >
                <template
                  v-if="factoryForm.factoryCooperationList.length !== 0"
                >
                  <div
                    v-for="(item, index) in factoryForm.factoryCooperationList"
                    :key="index"
                    class="Partner"
                  >
                    <div>
                      <el-image
                        style="width: 100px; height: 100px; flex: 2"
                        :src="item.cooperationPic"
                        :preview-src-list="[item.cooperationPic]"
                        fit="contain"
                      ></el-image>
                      <span
                        style="margin-left: 10px; font-size: 18px; flex: 8"
                        >{{ item.cooperationName }}</span
                      >
                    </div>
                    <el-button
                      type="warning"
                      size="small"
                      @click="deleteRow(index)"
                      >删除</el-button
                    >
                  </div>
                </template>
              </el-form-item>
              <el-form-item label="原料供应商：" v-if="fieldName.indexOf('OEM&ODM') !== -1">
                <el-button type="text" @click="factoryCooperVisible = true"
                  >添加原料供应商</el-button
                >
                <template>
                  <div
                    v-for="(item, index) in factoryForm.factorySupplierList"
                    :key="index"
                    class="Partner"
                  >
                    <div>
                      <el-image
                        style="width: 100px; height: 100px; flex: 2"
                        :src="item.supplierPic"
                        :preview-src-list="[item.supplierPic]"
                        fit="contain"
                      ></el-image>
                      <span
                        style="margin-left: 10px; font-size: 18px; flex: 8"
                        >{{ item.supplierName }}</span
                      >
                    </div>
                    <el-button
                      type="warning"
                      size="small"
                      @click="deleteRowSupplier(index)"
                      >删除</el-button
                    >
                  </div>
                </template>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
        <!-- 服务商管理 -->
        <el-row type="flex" justify="center">
          <el-col :span="18" v-if="serviceShow">
            <el-form
              ref="providerForm"
              class="add-form"
              :rules="providerRules"
              :model="providerForm"
              label-width="120px"
            >
              <el-form-item label="一级品类：" prop="firstCategory">
                <el-checkbox-group
                  v-model="providerForm.firstCategory"
                  @change="firstChange"
                  :max="3"
                >
                  <template v-for="(item, index) in firstList">
                    <el-checkbox :label="item.id" :key="index">{{
                      item.name
                    }}</el-checkbox>
                  </template>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="二级品类：">
                <div v-for="(item, index) in secondList" :key="index">
                  <span style="color: blue">{{ item.name }}：</span
                  >{{ item.data.join(",") }}
                </div>
              </el-form-item>
              <el-form-item label="banner图：" prop="supplierPic">
                <xcUpload @success="getBannerSupplier" :img="supplierPicData" :limit="20" />
              </el-form-item>
              <el-form-item label="合作客户：">
                <el-button type="text" @click="providerPartnerVisible = true"
                  >添加合作客户</el-button
                >
                <template v-if="providerForm.providerPartnerList.length">
                  <div
                    v-for="(item, index) in providerForm.providerPartnerList"
                    :key="index"
                    class="Partner"
                  >
                    <div>
                      <el-image
                        style="width: 100px; height: 100px; flex: 2"
                        :src="item.logo"
                        :preview-src-list="[item.logo]"
                        fit="contain"
                      ></el-image>
                      <span
                        style="margin-left: 10px; font-size: 18px; flex: 8"
                        >{{ item.partnerName }}</span
                      >
                    </div>
                    <el-button
                      type="warning"
                      size="small"
                      @click="deleteRow(index)"
                      >删除</el-button
                    >
                  </div>
                </template>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
        <el-row type="flex" justify="center">
          <el-col :span="18" v-if="isDr">
            <el-form
                ref="drForm"
                class="add-form"
                :rules="drRules"
                :model="drForm"
                label-width="120px"
            >
              <el-form-item label="一级品类：" prop="firstCategory">
                <el-checkbox-group
                    v-model="drForm.firstCategory"
                    @change="drFirstChange"
                    :max="3"
                >
                  <template v-for="(item, index) in drFirstList">
                    <el-checkbox :label="item.id" :key="index">{{
                        item.name
                      }}</el-checkbox>
                  </template>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="二级品类：">
                <div v-for="(item, index) in drSecondList" :key="index">
                  <span style="color: blue">{{ item.name }}：</span
                  >{{ item.data.join(",") }}
                </div>
              </el-form-item>
              <el-form-item label="banner图：" prop="bannerUrl">
                <xcUpload @success="getDrBanner" :img="drBannerData" :limit="20" />
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
        <el-row type="flex" justify="center">
          <el-col :span="18">
            <div class="info-footer">
              <el-button type="primary" @click="save">确定</el-button>
              <el-button
                v-if="factoryShow || serviceShow"
                @click="onlinePreview"
                >网页预览</el-button
              >
              <el-button type="primary" v-if="(factoryShow || serviceShow) && basicForm.status === '2'"  @click="getCord">获取二维码</el-button>
            </div>
          </el-col>
        </el-row>
      </el-card>
      <el-dialog title="合作客户" :visible.sync="providerPartnerVisible">
        <el-form
          ref="providerPartnerForm"
          :model="providerPartnerForm"
          class="add-form"
          :rules="providerPartnerRules"
        >
          <el-form-item
            label="合作商名称"
            label-width="120px"
            prop="partnerName"
          >
            <el-input
              v-model="providerPartnerForm.partnerName"
              autocomplete="off"
              placeholder="请输入合作商名称"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="logo地址"
            label-width="120px"
            style="margin-top: 20px"
            prop="logo"
          >
            <uploadImage @success="getPartnerLogo" :img="partnerLogoList" />
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="cancel">取 消</el-button>
          <el-button type="primary" @click="providerPartnerSave"
            >确 定</el-button
          >
        </div>
      </el-dialog>

      <el-dialog title="原料供应商" :visible.sync="factoryCooperVisible">
        <el-form
          ref="factorySupplierForm"
          :model="factorySupplierForm"
          :rules="factorySupplierRules"
          class="add-form"
        >
          <el-form-item
            label="原料供应商名称"
            label-width="120px"
            prop="partnerName"
          >
            <el-input
              v-model="factorySupplierForm.supplierName"
              autocomplete="off"
              placeholder="请输入原料供应商名称"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="logo地址"
            label-width="120px"
            style="margin-top: 20px"
            prop="supplierPic"
          >
            <uploadImage @success="getSupplierPic" :img="supplierPicList" />
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="factorySupplierCancel">取 消</el-button>
          <el-button type="primary" @click="factorySupplierSave"
            >确 定</el-button
          >
        </div>
      </el-dialog>
    </div>

    <transition name="phone">
      <div class="phone-box" v-if="onlineShow" @click="onlineShow = false">
        <iphoneX v-model="onlineShow" :src="onlineUrl" />
      </div>
    </transition>
  </div>
</template>

<script>
import navHeader from '../../components/navHeader.vue'
import uploadImage from '../../components/uploadImage.vue'
import xcUpload from '../../components/xcUpload.vue'
import propagandaUpload from '../../components/propagandaUpload.vue'
import editor from '../../components/editor2.vue'
import iphoneX from '../../components/iphonex.vue'
import videoUpload from '../../components/videoUpload'

export default {
  data () {
    return {
      dialogFwVisible: false,
      tipsFwChecked: false,
      dialogPpVisible: false,
      tipsPpChecked: false,
      loading: true,
      onlineId: '',
      onlineUrl: '',
      onlineShow: false,
      isDisabled: true,
      tipsUrl: '',
      typeList: [
        {
          label: '日化品牌展商',
          value: '1'
        },
        {
          label: '专业品牌展商',
          value: '2'
        },
        {
          label: '工厂展商',
          value: '3'
        },
        {
          label: '服务商展商',
          value: '4'
        },
        {
          label: '达人机构',
          value: '5'
        }
      ],
      mobile: '',
      basicForm: {
        // 首页基本表单
        fullName: '', // '全称',
        shortName: '', // '简称',
        englishName: '', // '英文名',
        type: '', // 品牌类型1
        introduction: '', // '简介（富文本）',
        showroom: '', // '展馆',
        boothNumber: '', // '展位号',
        province: '', // '省份（下拉列表传省份编码）',
        address: '', // '详细地址',
        sessions: '', // '参展届数',
        manager: '', // '客户经理',
        validityDate: '', // '2022-04-04',
        logo: '', // '图片Logo地址'
        sort: '',
        sceneRosterList: []
      },
      factoryForm: {
        // 工厂管理表单
        foreignTrade: '',
        foreignTradeProportion: '',
        factoryPic: '', // 工厂图片地址,
        one: '', // 一级品类id，多个,拼接
        two: '', // 二级品类id，多个,拼接
        selectTwo: [],
        mainList: [],
        main: '', // 主推品类id，多个,拼接，最多选三个
        serviceRangeList: [],
        serviceRange: '', // 服务范围,
        recording: '1', // 是否能产品备案  1  是 2 否,
        yearlyOutput: '', // 年产量,
        devPeople: '', // 研发人数,
        formulaNum: '', // 配方数,
        patent: '', // 专利数,
        minOrder: '', // 起订量,
        pack: '', // 包装种类,
        design: '1', // 是否可以设计 1  是  2  否,
        modelNum: '', // 模具数量,
        patent2: '', // 专利数2,
        yearlyOutput2: '', // 年产量2,
        minOrder2: '', // 起订量2,
        yearlyOutput3: '', // 年产值3,
        devPeople3: '', // 研发人数3,
        formulaNum3: '', // 配方数,
        patent3: '', // 专利数3,
        minOrder3: '', // 起订量3,
        devPeople4: '', // 研发工程师4,
        patent4: '', // 专利数4,
        yearlyOutput4: '', // 年产值4,
        factoryCooperationList: [],
        factorySupplierList: [],
        factoryAddressList: [],
        isCustomization: '',
        factoryArea: '',
        packingDevelopNum: ''
      },
      providerForm: {
        firstCategory: [], // "1,2,3(一级品类)",
        secondCategory: '', // "1,2,3(二级品类)",
        supplierPic: '',
        providerAddressList: [],
        providerPartnerList: [],
        strength: []
      },
      addressList: [],
      factoryShow: false, // 工厂管理
      serviceShow: false, // 服务商管理
      isDr: false, // 达人
      oneList: [], // 一级品类列表
      twoList: [], // 二级品类
      selectMainList: [],
      firstList: [], // 服务商一级品类
      secondList: [], // 服务商二级品类
      basicRules: {
        shortName: [
          { required: true, message: '请输入简称' },
          // { max: 10, message: '长度在10个字内', trigger: 'blur' }
          {
            validator: function (rule, value, callback) {
              if (value.replace(/[^\x00-\xff]/g, '**').length <= 20) {
                callback()
              } else {
                callback(new Error('长度在10个字或20个字符内'))
              }
            },
            trigger: 'blur'
          }
        ],
        introduction: { required: true, message: '请输入简介' },
        logo: { required: true, message: '请上传图片', trigger: 'blur' },
        address: { required: true, message: '请输入地址' },
        province: { required: true, message: '请输入地址' },
        englishName: [
          {
            required: false
          },
          {
            validator: function (rule, value, callback) {
              if (!(/[\u4E00-\u9FA5]/g.test(value))) {
                callback()
              } else {
                callback(new Error('请输入英文'))
              }
            },
            trigger: 'blur'
          }
        ]
      }, // 首页基本校验
      logoList: [], // logo图列表
      videoList: [],
      factoryPicList: [], // 工厂图列表
      fieldType: [], // 当一级品类改变时满足条件显示
      fieldName: [],
      factoryRules: {
        // 工厂管理校验
        // foreignTrade: {
        //   required: true,
        //   message: '请选择是否做外贸',
        //   trigger: 'change'
        // },
        // foreignTradeProportion: {
        //   required: true,
        //   message: '请输入外贸占比',
        //   trigger: 'change'
        // },
        one: {
          required: true,
          message: '请选择一级品类',
          trigger: 'change'
        },
        origin: {
          required: true,
          message: '请输入原产地',
          trigger: 'blur'
        },
        factoryPic: {
          required: true,
          message: '请上传工厂图片，大小不能超过 5MB!',
          trigger: 'change'
        },
        serviceRangeList: {
          required: true,
          message: '请选择服务范围',
          trigger: 'blur'
        },
        recording: {
          required: true,
          message: '请选择产品备案',
          trigger: 'change'
        },
        pack: {
          required: true,
          message: '请输入二级品类',
          trigger: 'blur'
        },
        design: {
          required: true,
          message: '请选择设计',
          trigger: 'blur'
        },
        selectTwo: {
          required: true,
          message: '请选择二级品类',
          trigger: 'blur'
        },
        mainList: {
          required: true,
          message: '请选择主推品类',
          trigger: 'blur'
        }
      }, // 工厂管理校验
      providerRules: {
        firstCategory: {
          required: true,
          message: '请选择一级品类',
          trigger: 'change'
        },
        supplierPic: {
          required: true,
          message: '请上传banner图',
          trigger: 'change'
        }
      }, // 服务商管理校验
      providerPartnerVisible: false, // 合作客户弹框
      providerPartnerForm: {
        partnerName: '',
        logo: ''
      },
      supplierPicData: [],
      providerPartnerRules: {
        partnerName: {
          required: true,
          message: '请输入合作商名称',
          trigger: 'blur'
        },
        logo: {
          required: true,
          message: '请上传logo图片，大小不能超过 5MB!',
          trigger: 'change'
        }
      },
      drRules: {
        firstCategory: {
          required: true,
          message: '请选择一级品类',
          trigger: 'change'
        },
        bannerUrl: {
          required: true,
          message: '请上传banner图',
          trigger: 'change'
        }
      },
      drForm: {
        firstCategory: '',
        bannerUrl: ''
      },
      drFirstList: [],
      drSecondList: [],
      drBannerData: [],
      partnerLogoList: [],
      areaCodeList: [], // 省份
      province: '',
      address: '',
      provinceCode: '',
      companyId: 0,
      factorySupplierVisible: false,
      factorySupplierForm: {
        supplierName: '',
        supplierPic: ''
      },
      factorySupplierRules: {
        supplierName: {

        },
        supplierPic: {

        }
      },
      supplierPicList: [],
      factoryCooperVisible: false,

      addressForm: {
        addressList: []
      },
      addressRules: {},
      cbeList: [],
      sceneRosterList: []
    }
  },
  components: {
    navHeader,
    uploadImage,
    xcUpload,
    propagandaUpload,
    editor,
    iphoneX,
    videoUpload
  },
  mounted () {
    this.getBrandCategoryList() // 查询一级品类
    this.getFirstList() // 查询服务商一级品类
    this.getDrFirstList()
    this.areaCode()
    this.getCbeBaseInfoList()
  },
  methods: {
    getCbeBaseInfoList () {
      this.$http.post('/cbeBaseInfo/getList').then(res => {
        console.log(res)
        if (res.data.code === '200') {
          this.cbeList = res.data.data
        }
      })
    },
    onlinePreview () {
      if (this.factoryShow) {
        this.onlineId = this.factoryForm.id
        this.onlineUrl = `/pages/Supply_chain_details/Supply_chain_details?id=${this.onlineId}&type=6`
      }
      if (this.serviceShow) {
        this.onlineId = this.providerForm.id
        this.onlineUrl = `/pages/supplier/detail?id=${this.onlineId}&type=7`
      }
      this.onlineShow = true
    },
    getCord () {
      if (this.factoryShow) {
        this.onlineId = this.factoryForm.id
        this.onlineUrl = `/wechatQRCode/getWechatQRCode/5/${this.onlineId}`
      }
      if (this.serviceShow) {
        this.onlineId = this.providerForm.id
        this.onlineUrl = `/wechatQRCode/getWechatQRCode/7/${this.onlineId}`
      }
      this.$http.get(this.onlineUrl, {responseType: 'blob'}).then(res => {
        console.log(res)
        const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/x-msdownload' }))
        const link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.download = this.basicForm.shortName + '二维码.png'
        document.body.appendChild(link)
        link.click()
        window.URL.revokeObjectURL(link.href)
        document.body.removeChild(link)
      })
    },
    // 获取权限
    getRole () {
      this.$http
        .post('/company/getById', {})
        .then((res) => {
          if (res.data.code === '200') {
            let data = res.data.data
            this.videoList = []
            this.mobile = data.sysUser.mobile
            this.basicForm = Object.assign(this.basicForm, data)
            const sceneRosterList = res.data.data.sceneRosterList || []
            this.basicForm.sceneRosterList = sceneRosterList.length ? sceneRosterList : [{sceneId: '', showroom: '', boothNumber: '', boothCount: 0, area: 0, contractNo: ''}]
            this.sceneRosterList = sceneRosterList
            let list = this.basicForm.videoUrl ? this.basicForm.videoUrl.split(',') : []
            list.forEach(item => {
              this.videoList.push({name: item, url: item})
            })
            this.isDisabled = this.basicForm.address && this.basicForm.province
            if (data.provider) {
              this.serviceShow = true
              this.addressForm.addressList = data.provider.providerAddressList ? data.provider.providerAddressList : []
              this.providerForm = data.provider
                ? Object.assign(this.providerForm, data.provider)
                : {}
              this.providerForm.firstCategory =
                data.provider && data.provider.firstCategory
                  ? data.provider.firstCategory.split(',')
                  : []
              this.providerForm.strength =
                data.provider && data.provider.strength
                  ? data.provider.strength.split(',')
                  : []
              this.supplierPicData = this.providerForm.supplierPic
                ? this.providerForm.supplierPic.split(',')
                : []
              if (this.providerForm.firstCategory.length > 0) {
                this.firstChange()
              }
            } else if (data.factory) {
              this.factoryShow = true
              this.addressForm.addressList = data.factory.factoryAddressList ? data.factory.factoryAddressList : []
              this.factoryForm = data.factory
                ? Object.assign(this.factoryForm, data.factory)
                : {}
              if (!this.factoryForm.foreignTrade) this.factoryForm.foreignTrade = ''
              this.factoryPicList = this.factoryForm.factoryPic
                ? this.factoryForm.factoryPic.split(',')
                : []
              this.factoryForm.selectTwo =
                data.factory && data.factory.two
                  ? data.factory.two.split(',')
                  : []
              if (this.factoryForm.selectTwo.length > 0) {
                this.twoList = []
                this.oneList.forEach((item) => {
                  if (this.factoryForm.one === item.id) {
                    this.twoList = item.childList
                  }
                })
              }
              this.oneChange(this.factoryForm.one, 'detail')
              this.factoryForm.mainList =
                data.factory && data.factory.main
                  ? data.factory.main.split(',')
                  : []
              this.factoryForm.serviceRangeList =
                data.factory && data.factory.serviceRange
                  ? data.factory.serviceRange.split(',')
                  : []
              this.getSelectMainList(this.factoryForm.selectTwo, 'detail')
            } else if (data.talentOrg) {
              this.addressForm.addressList = data.talentOrg.talentAddressList ? data.talentOrg.talentAddressList : []
              this.drForm = data.talentOrg
                ? Object.assign(this.drForm, data.talentOrg)
                : {}
              this.drForm.firstCategory =
                  data.talentOrg && data.talentOrg.firstCategory
                    ? data.talentOrg.firstCategory.split(',')
                    : []
              this.drBannerData = data.talentOrg.bannerUrl ? data.talentOrg.bannerUrl.split(',') : []
              if (this.drForm.firstCategory.length > 0) {
                this.drFirstChange()
              }
            } else {
              this.serviceShow = false
              this.factoryShow = false
            }
            this.isDr = data.type === '5'
            this.logoList = this.basicForm.logo
              ? this.basicForm.logo.split(',')
              : []
            this.loading = false

            if (this.serviceShow || this.factoryShow) {
              this.tipsUrl = 'fw'
            } else {
              this.tipsUrl = 'pp'
            }
            if (this.tipsUrl === 'fw') {
              this.dialogFwVisible = !(localStorage.getItem('firstFw') && localStorage.getItem('fwTip'))
            }
            if (this.tipsUrl === 'pp') {
              this.dialogPpVisible = !(localStorage.getItem('firstPp') && localStorage.getItem('ppTip'))
            }
          } else {
            this.$message.error(res.data.msg)
            this.loading = false
          }
        })
        .catch((e) => {
          this.$message.error(e)
          this.loading = false
        })
    },
    setHtml (html) {
      this.basicForm.introduction = html
    },
    areaCode () {
      this.$http
        .get('/areaCode/getList')
        .then((res) => {
          if (res.data.code === '200') {
            this.areaCodeList = res.data.data
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch((e) => {
          console.log(e)
        })
    },
    // 一级品类改变二级品类
    oneChange (node, type) {
      this.fieldType = node
      let list = []
      this.oneList
        .filter((item) => {
          if (node && node.indexOf(item.id) !== -1) {
            return item.name
          }
        })
        .map((item) => {
          list.push(item.name.replace(/\s/g, ''))
        })
      this.fieldName = list
      if (type !== 'detail') {
        this.factoryForm.selectTwo = []
      }
      this.twoList = []
      this.selectMainList = []
      this.factoryForm.mainList = []
      this.oneList.forEach((item) => {
        if (this.factoryForm.one === item.id) {
          this.twoList = item.childList
        }
      })
    },
    getSelectMainList (node, type) {
      this.selectMainList = []
      console.log(node)
      if (type !== 'detail') {
        this.factoryForm.mainList = []
      }
      this.twoList.forEach(item => {
        node.forEach(i => {
          if (i === item.id) {
            this.selectMainList.push(item)
          }
        })
      })
    },
    // 查询一级品类
    getBrandCategoryList () {
      this.$http
        .post('/brandCategory/getCategoryByType', { type: '3' })
        .then((res) => {
          if (res.data.code === '200') {
            this.oneList = res.data.data
            this.getRole()
          }
        })
    },
    // 一级品类改变二级品类
    firstChange () {
      this.secondList = []
      this.firstList.forEach((item) => {
        this.providerForm.firstCategory.forEach((i) => {
          if (i === item.id) {
            this.secondList.push({
              name: item.name,
              id: item.id,
              data: item.childList.map((n) => n.name)
            })
          }
        })
      })
    },
    drFirstChange () {
      this.drSecondList = []
      this.drFirstList.forEach((item) => {
        this.drForm.firstCategory.forEach((i) => {
          if (i === item.id) {
            this.drSecondList.push({
              name: item.name,
              id: item.id,
              data: item.childList.map((n) => n.name)
            })
          }
        })
      })
    },
    getDrFirstList () {
      this.$http
        .post('/brandCategory/getCategoryByType', { type: '5' })
        .then((res) => {
          if (res.data.code === '200') {
            this.drFirstList = res.data.data
          }
        })
    },
    // 查询一级品类
    getFirstList () {
      this.$http
        .post('/brandCategory/getCategoryByType', { type: '4' })
        .then((res) => {
          if (res.data.code === '200') {
            this.firstList = res.data.data
          }
        })
    },
    // logo图callback
    getLogo (list) {
      this.basicForm.logo = list.join(',')
    },
    getVideo (list) {
      this.basicForm.videoUrl = list.map(item => item.url).join(',')
    },
    // banner图callback
    getBannerSupplier (list) {
      this.providerForm.supplierPic = list.join(',')
    },
    // 合作商logo callback
    getPartnerLogo (list) {
      this.providerPartnerForm.logo = list.join(',')
    },
    // 工厂供应商
    getSupplierPic (list) {
      this.factorySupplierForm.supplierPic = list.join(',')
    },
    factorySupplierCancel () {
      this.factoryCooperVisible = false
      this.factorySupplierForm = {
        supplierName: '',
        supplierPic: ''
      }
      this.supplierPicList = []
    },
    factorySupplierSave () {
      this.$refs.factorySupplierForm.validate((val) => {
        if (val) {
          let form = JSON.parse(JSON.stringify(this.factorySupplierForm))
          this.factoryForm.factorySupplierList.push(form)
          this.factoryCooperVisible = false
          this.factorySupplierForm = {
            supplierName: '',
            supplierPic: ''
          }
          this.supplierPicList = []
        }
      })
    },
    deleteRowSupplier (index) {
      this.factoryForm.factorySupplierList.splice(index, 1)
    },
    // 工厂图callback
    getFactoryPic (list) {
      this.factoryForm.factoryPic = list.join(',')
    },
    getDrBanner (list) {
      this.drForm.bannerUrl = list.join(',')
    },
    back () {
      this.$router.push('/businessInfo')
    },
    // 弹框确认
    providerPartnerSave () {
      this.$refs.providerPartnerForm.validate((val) => {
        if (val) {
          let form = JSON.parse(JSON.stringify(this.providerPartnerForm))
          if (this.factoryShow) {
            form.cooperationName = this.providerPartnerForm.partnerName
            form.cooperationPic = this.providerPartnerForm.logo
            delete form.partnerName
            delete form.logo
            this.factoryForm.factoryCooperationList.push(form)
          }
          if (this.serviceShow) {
            this.providerForm.providerPartnerList.push(form)
          }
          this.providerPartnerVisible = false
          this.providerPartnerForm = {
            partnerName: '',
            logo: ''
          }
          this.partnerLogoList = []
        }
      })
    },
    // 弹框取消
    cancel () {
      this.providerPartnerVisible = false
      this.$refs.providerPartnerForm.resetFields()
      this.providerPartnerForm = {
        partnerName: '',
        logo: ''
      }
      this.partnerLogoList = []
    },
    deleteRow (index) {
      if (this.serviceShow) {
        this.providerForm.providerPartnerList.splice(index, 1)
      }
      if (this.factoryShow) {
        this.factoryForm.factoryCooperationList.splice(index, 1)
      }
    },
    // 添加地址
    addAddress () {
      this.addressForm.addressList.push({
        province: '',
        address: ''
      })
    },
    // 删除地址
    deleteAddress (n) {
      this.addressForm.addressList.splice(n, 1)
    },
    save () {
      const formName = ['basicForm', 'factoryForm1', 'providerForm', 'drForm']
      const validates = (item) => {
        return new Promise((resolve, reject) => {
          if (!this.$refs[item]) {
            resolve()
            return false
          }
          this.$refs[item].validate((valid) => {
            if (valid) {
              resolve()
            } else {
              reject(new Error('验证不对'))
            }
          })
        })
      }
      Promise.all(formName.map((item) => validates(item)))
        .then(() => {
          if (!this.basicForm.shortName) return this.$message.error('请输入简称')
          if (!this.basicForm.introduction) return this.$message.error('请输入简介')
          if (!this.basicForm.province) return this.$message.error('请输入地址')
          if (!this.basicForm.address) return this.$message.error('请输入地址')
          let params = JSON.parse(JSON.stringify(this.factoryForm))
          let params1 = JSON.parse(JSON.stringify(this.providerForm))
          let params2 = JSON.parse(JSON.stringify(this.drForm))
          this.basicForm.sessions = Number(this.basicForm.sessions)
          this.basicForm.sort = Number(this.basicForm.sort)
          if (this.factoryShow) {
            params.factoryCooperationList = []
            this.factoryForm.factoryCooperationList.forEach(item => {
              params.factoryCooperationList.push({
                cooperationName: item.cooperationName,
                cooperationPic: item.cooperationPic
              })
            })
            params.factorySupplierList = []
            this.factoryForm.factorySupplierList.forEach(item => {
              params.factorySupplierList.push({
                supplierName: item.supplierName,
                supplierPic: item.supplierPic
              })
            })
            params.factoryAddressList = []
            if (this.addressForm.addressList && this.addressForm.addressList.length > 0) {
              this.addressForm.addressList.forEach(item => {
                params.factoryAddressList.push({
                  province: item.province,
                  address: item.address
                })
              })
            }
            if (params.factoryAddressList.length === 0) {
              params.factoryAddressList = null
            }
            if (params.factoryCooperationList.length === 0) {
              params.factoryCooperationList = null
            }
            if (params.factorySupplierList.length === 0) {
              params.factorySupplierList = null
            }
            params.two = this.factoryForm.selectTwo.join(',')
            params.main = this.factoryForm.mainList.join(',')
            params.serviceRange = this.factoryForm.serviceRangeList.join(',')
            delete params.selectTwo
            delete params.mainList
            delete params.serviceRangeList
            params1 = {}
          } else {
            params = {}
          }
          if (this.serviceShow) {
            params1.providerPartnerList = []
            this.providerForm.providerPartnerList.forEach(item => {
              params1.providerPartnerList.push({
                partnerName: item.partnerName,
                logo: item.logo
              })
            })
            params1.providerAddressList = []
            if (this.addressForm.addressList && this.addressForm.addressList.length > 0) {
              this.addressForm.addressList.forEach(item => {
                params1.providerAddressList.push({
                  province: item.province,
                  address: item.address
                })
              })
            }
            params1.strength = this.providerForm && this.providerForm.strength ? this.providerForm.strength.join(',') : []
            params1.firstCategory = this.providerForm && this.providerForm.firstCategory ? this.providerForm.firstCategory.join(',') : []
            params1.secondCategory = this.secondList.join(',')
            params = {}
          } else {
            params1 = {}
          }
          if (this.isDr) {
            params2.firstCategory = this.drForm.firstCategory.join(',')
          }
          const sceneRosterList = this.basicForm.sceneRosterList
          const ids = sceneRosterList.map((item) => item.id)
          const addSceneRosterList = sceneRosterList.filter((item) => !item.id)
          const updateSceneRosterList = sceneRosterList.filter((item) => item.id)
          const delSceneRosterList = this.sceneRosterList.filter((item) => !ids.includes(item.id))
          const paramsNew = JSON.parse(JSON.stringify(this.basicForm))
          paramsNew.addSceneRosterList = addSceneRosterList
          paramsNew.updateSceneRosterList = updateSceneRosterList
          paramsNew.delSceneRosterList = delSceneRosterList
          let submitList = {
            ...paramsNew,
            factory: { ...params },
            provider: { ...params1 },
            talentOrg: { ...params2 }
          }
          let url = '/company/update'
          this.$http
            .post(url, submitList)
            .then((res) => {
              if (res.data.code === '200') {
                this.$message.success(res.data.msg)
                this.getRole()
              } else {
                this.$message.error(res.data.msg)
              }
            })
            .catch((e) => {
              this.$message.error('保存失败')
              console.log(e)
            })
        })
        .catch(() => {
          if (!this.basicForm.shortName) return this.$message.error('请输入简称')
          if (!this.basicForm.introduction) return this.$message.error('请输入简介')
          if (!this.basicForm.province) return this.$message.error('请输入地址')
          if (!this.basicForm.address) return this.$message.error('请输入地址')
        })
    },
    addScene () {
      this.basicForm.sceneRosterList.push({sceneId: '', showroom: '', boothNumber: '', boothCount: 0, area: 0, contractNo: ''})
    },
    deleteScene (index) {
      this.basicForm.sceneRosterList = this.basicForm.sceneRosterList.filter((item, idx) => index !== idx)
    }
  }
}
</script>

<style lang="less">
.detail-box {
  .tips-image {
    height: 386px;
    margin: 0 auto;
  }
  .tips-pp {
    width: 1150px;
    background: url('../../assets/images/pp.png') no-repeat center center;
    background-size: cover;
  }
  .tips-fw {
    width: 988px;
    height: 437px;
    background: url('../../assets/images/fw.png') no-repeat center center;
    background-size: cover;
  }
}
.Partner {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.Partner div {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.bhText {
  color: #ff3040;
}
.otherText {
  color: #6da09c;
}
</style>



// WEBPACK FOOTER //
// src/pages/home/home.vue